import React, { useEffect, useState } from "react";
import "../../Styles/NFTbox.css";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Dashboardheader from "../../directives/dashboardheader";
import config from "../../config/config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import toast from "react-hot-toast";
import { ShimmerCategoryList, ShimmerThumbnail } from "react-shimmer-effects";
import Web3 from "web3";
import Cookies from "js-cookie";
import { adressUpdateAction, getDataForNftDetailsAction, UserProfile } from "../../Action/user.action";
import NftsuccessfulModal from "../Modals/NftsuccessfulModal";
import CopyToClipboard from "react-copy-to-clipboard";
import { Vortex } from "react-loader-spinner";
import NftboxModal from "../Modals/nftBoxModel";
import NftboxLoadModal from "../Modals/NftboxLoadModal";
import Swal from "sweetalert2";

const NftboxPurchaseDetails = () => {
  const navigate = useNavigate()
  const [buyTransactionHash, setbuyTransactionHash] = useState("");
  const [MintingTimer, setMintingTimer] = useState("");
  const [transactionError, settransactionError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [nftBoxDetails, setNftBoxDetails] = useState([])
  const [rewardCategoriesDetails, setRewardCategoriesDetails] = useState([])
  const [isChecked, setIsChecked] = useState(false);
  const [showNftSuccessModal, setShowNftSuccessModal] = useState(false)
  const [process, setprocess] = useState("");
  const [showModalLoad, setShowModalLoad] = useState(false);
  const [userData, setUserData] = useState(null);

  const [mntData, setMntData] = useState([])


  const handleCloseNftSuccessPop = () => {
    navigate(`${config.baseUrl}nftboxdetails`)
  }


  let { nftBoxValue } = useParams();

  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
      Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
    );

  useEffect(() => {
    if (nftBoxValue == 0) {
      navigate(`${config.baseUrl}nftbox`)
    } else {
      getDataForNftDetails()
      getUserProfile();
    }
  }, [])

  const getUserProfile = async () => {
    let res = await UserProfile();
    if (res.success) {
      setUserData(res.data);
    } else {
      setUserData([]);
    }
  };

  const handleAddMore = () => {
    navigate(`${config.baseUrl}nftbox`, { state: { nftBoxValue } })
  }

  // NFT Box purchasing functions
  const approve = async (
    abi,
    contractAddress,
    amount,
    toAddress,
    from_address
  ) => {

    setprocess("Your approval is processing");

    let web3 = new Web3(window.ethereum);
    const contract = new web3.eth.Contract(abi, contractAddress);
    let allowance = await contract.methods
      .allowance(from_address, toAddress)
      .call();

    allowance = parseFloat((parseInt(allowance) / 10 ** 18).toFixed(6));
    if (allowance >= amount) {
      return true;
    }
    amount = web3.utils.toWei(amount.toString(), "ether");
    try {
      let approve = await contract.methods.approve(toAddress, amount);
      let encoded_tx = approve.encodeABI();
      let gasPrice = await web3.eth.getGasPrice();

      //fees for approval & buyPlan trx
      let getBalace = await web3.eth.getBalance(from_address);
      let fees = ((47000 + 285000) * parseInt(gasPrice)) / 10 ** 18;
      let currentBal = parseFloat((parseInt(getBalace) / 10 ** 18).toFixed(6));
      if (fees > currentBal) {
        toast.error(
          `Insufficient gas fee for transaction, Minimum ${parseFloat(
            fees
          ).toFixed(6)} BNB balanace required for transaction`
        );
        setShowModal(false);
        return false;
      }

      let gasLimit = await web3.eth.estimateGas({
        gasPrice: web3.utils.toHex(gasPrice),
        to: contractAddress,
        from: from_address,
        data: encoded_tx,
      });
      let trx = await web3.eth.sendTransaction({
        gasPrice: web3.utils.toHex(gasPrice),
        gas: web3.utils.toHex(gasLimit),
        to: contractAddress,
        from: from_address,
        data: encoded_tx,
      });
      if (trx.transactionHash) {
        return true;
      } else {
        toast.error("User Reject Approval");

        setShowModal(false);
        return false;
      }
    } catch (err) {
      if (err.code == 4001) {
        toast.error("User Reject Approval");
      } else if (err.code == -32603) {
        toast.error("Insufficient Allowance");
      } else {
        toast.error(err.message);
      }
      setShowModal(false);
      return false;
    }
  };

  const handleBuyNFTBox = async (e, id) => {
    if (!isChecked) {
      toast.dismiss()
      toast.error('Please first agree to the terms')
      return
    }
    if (!nftBoxValue) {
      toast.error('Please Nft Box Value')
      return
    }

    if (userData.bnb_address == null) {
      handleWalleteVerificationModal(e);
      return;
    }

    try {
      if (loginData.bnb_address == null) {
        // handleWalleteVerificationModal(e);
      } else {
        setShowModal(true);
        setprocess("Your Transaction is processing");
        // if (!loginData.id) {
        //   setShowModal(false);
        //   toast.error(
        //     "You need to connect with your Meta mask Wallet before purchase"
        //   );
        //   return;
        // }
        if (window.ethereum) {
          let web3 = new Web3(window.ethereum);

          let chainId;
          try {
            chainId = await web3.currentProvider.chainId;
            if (!chainId) {
              chainId = await web3.currentProvider.getChainId();
            }
          } catch (error) {
            window.location.reload();
            return false;
          }
          if (
            chainId != config.chainId &&
            web3.utils.toHex(parseInt(chainId)) != config.chainId
          ) {
            toast.error(`Please select BNB smartchain!!`);
            setShowModal(false);
            return false;
          }
          let MrmintContractCall = new web3.eth.Contract(
            config.mrmintContractAbi,
            config.contractAddressForRecharge
          );

          const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
          });
          let from_address = accounts[0];
          if (loginData.bnb_address && loginData.bnb_address.toLowerCase() != from_address.toLowerCase()) {
            toast.error(`Please connect with registered wallet`);
            setShowModal(false);
            return false;
          }
          let balanceOf = await MrmintContractCall.methods
            .balanceOf(accounts[0])
            .call();
          let contractWallet = new web3.eth.Contract(
            config.nftBoxContractAbi,
            config.nftBoxPurchaseContractAddress
          );
          let usdtValue = nftBoxValue;
          let usdt = Web3.utils.toWei(usdtValue.toString(), "ether");
          let getpurchaseStepByToken = await contractWallet.methods
            .getUsdtInMnt(usdt.toString())
            .call();

          let updateAmountToken = parseFloat(
            (parseInt(getpurchaseStepByToken) / 10 ** 18 + 5).toFixed(6)
          );
          // setPlanPrice(updateAmountToken);
          balanceOf = parseFloat((parseInt(balanceOf) / 10 ** 18).toFixed(6));
          if (!loginData.id) {
            setShowModal(false);
            toast.error(
              "You need to connect with your Meta mask Wallet before purchase"
            );
            return;
          }
          if (updateAmountToken > balanceOf) {
            toast.error(`Insufficient Balance`);
            setShowModal(false);
            return;
          }
          let approval = await approve(
            config.mrmintContractAbi,
            config.contractAddressForRecharge,
            updateAmountToken,
            config.nftBoxPurchaseContractAddress,
            from_address
          );

          if (approval) {
            try {
              setprocess("Your transaction is processing");
              let purchaseStepByToken = await contractWallet.methods.addInvestment(
                nftBoxValue / 100
              );

              let encoded_tx = purchaseStepByToken.encodeABI();
              let gasPrice = await web3.eth.getGasPrice();
              gasPrice = parseInt(gasPrice) + 5 * 10 ** 9;

              //fees for buyPlan trx
              let getBalace = await web3.eth.getBalance(from_address);
              let fees = (285000 * parseInt(gasPrice)) / 10 ** 18;
              let currentBal = parseFloat(
                (parseInt(getBalace) / 10 ** 18).toFixed(6)
              );
              if (fees > currentBal) {
                toast.error(
                  `Insufficient gas fee for transaction, Minimum ${parseFloat(
                    fees
                  ).toFixed(6)} BNB balanace required for transaction`
                );
                setShowModal(false);
                return false;
              }

              let gasLimit = await web3.eth.estimateGas({
                gasPrice: web3.utils.toHex(gasPrice),
                to: config.nftBoxPurchaseContractAddress,
                from: from_address,
                data: encoded_tx,
              });

              let trx = await web3.eth.sendTransaction({
                gasPrice: web3.utils.toHex(gasPrice),
                gas: web3.utils.toHex(gasLimit),
                to: config.nftBoxPurchaseContractAddress,
                from: from_address,
                data: encoded_tx,
              });
              if (trx) {
                setbuyTransactionHash(trx.transactionHash);
                toast.success("Transaction has been created successfully");
                setTimeout(() => {
                  setShowModal(true);
                  let timer = 120;
                  setInterval(() => {
                    timer -= 1;
                    setMintingTimer(timer);
                    if (timer <= 0) {
                      setShowNftSuccessModal(!showNftSuccessModal)
                      setShowModal(false);
                    }
                  }, 1500);
                }, 1000);
              }
            } catch (err) {
              setShowModal(false);
              if (err.code == -32603) {
                toast.error("Insufficent Allowance : " + err.message);
              }
              if (err.code == -32000) {
                toast.error("Gas Required Exceeds : " + err.message);
              }
              if (err.message.toString().split("insufficient funds")[1]) {
                settransactionError("Transaction reverted : " + err.message);
                toast.error("Transaction reverted : " + err.message);
              } else {
                if (err.toString().split("execution reverted:")[1]) {
                  toast.error(
                    "Transaction reverted : " +
                    err
                      .toString()
                      .split("execution reverted:")[1]
                      .toString()
                      .split("{")[0]
                  );
                  settransactionError(
                    "Transaction reverted : " +
                    err
                      .toString()
                      .split("execution reverted:")[1]
                      .toString()
                      .split("{")[0]
                  );
                } else {
                  settransactionError(err.message);
                  toast.error(err.message);
                }
              }
              setShowModal(false);
              return false;
            }
          }
          setShowModal(false);
        } else {
          toast.error("Please use Dapp browser!!");
          setShowModal(false);
        }
      }
    } catch (error) {
      console.log(error);
      switch (error.code) {
        case 4001:
          toast.error("User Rejected");
          break;
        case -32002:
          toast.error(
            "Request Already Processing, Please check your Meta Mask wallet"
          );
          break;
        case "ERR_NETWORK":
          toast.error("We're experiencing technical difficulties.");
          break;
        default:
          toast.error(error.message);
          break;
      }
      setShowModal(false);
    }
  };

  const [isLoading, setIsLoading] = useState(true);


  const getDataForNftDetails = async () => {
    try {
      const res = await getDataForNftDetailsAction(nftBoxValue)
      if (res.success) {
        setRewardCategoriesDetails(res.data.reward_categories)
        setNftBoxDetails(res.data.box_purchase_details)
        setMntData(res.data)
      }
    } catch (error) {
      console.log(error);

    }
    finally {
      setIsLoading(false);
    }
  }
  const copieBtn = async () => {
    toast.success(`Copied!!`);
  };

  const redirect = () => {
    setShowModalLoad(false);
    window.location.reload();
  };

  const handleNavigate = (data) => {

    navigate(`${config.baseUrl}nftbox`, { state: { nftBoxValue: data.min_amount } });
  };

  const handleWalleteVerificationModal = async (e) => {
    // e.preventDefault();
    const result = await Swal.fire({
      text: "⚠️ Warning: This is your final wallet address. Once saved, it cannot be changed. Please ensure it's correct before continuing.",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
    if (!result.isConfirmed) {
      return;
    }
    connectMetasmaskForAddress();
  };

  const connectMetasmaskForAddress = async (e) => {
    try {
      if (window.ethereum) {
        var web3 = new Web3(window.ethereum);
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        console.log(accounts, "///", window.ethereum);
        let chainId = await web3.currentProvider.chainId;
        if (!chainId) {
          chainId = web3.currentProvider.getChainId();
        }
        if (
          chainId != config.chainId &&
          web3.utils.toHex(parseInt(chainId)) != config.chainId
        ) {
          toast.error(`Please select BNB smartchain!!`);

          return false;
        } else {
          console.log(accounts[0]);
          if (accounts[0]) {
            let publicAddress = accounts[0];
            const { signature } = await new Promise((resolve, reject) =>
              web3.eth.personal.sign(
                web3.utils.fromUtf8(`Login Mrmint`),
                publicAddress,
                (err, signature) => {
                  if (err) return reject(err);
                  return resolve({ publicAddress, signature });
                }
              )
            );
            let res = await adressUpdateAction({
              bnb_address: accounts[0],
            });
            console.log("test3", res);
            if (res.success) {
              loginData.bnb_address = accounts[0];
              Cookies.set("loginSuccessStepMrMint", JSON.stringify(loginData));
              toast.success(res.msg);
              setTimeout(() => {
                window.location.href = `${config.baseUrl}nftboxpurchasedetails/${nftBoxValue}`;
              }, 1000)
            } else {
              toast.error(res.msg);
            }
          }
        }
      } else {
        toast.error("Please use Dapp browser!!");
      }
    } catch (error) {
      console.log("error", error);

      switch (error.code) {
        case 4001: // User rejected the request
          toast.error("User rejected the request.");
          break;
        case -32002: // Request already in progress
          toast.error(
            "Request already in progress. Please check your MetaMask wallet."
          );
          break;
        case "ERR_NETWORK": // Network issues
          toast.error("Network error. Please try again.");
          break;
        default:
          toast.error("An unexpected error occurred.");
          break;
      }
    }
  };

  return (
    <>
      <Dashboardheader />

      <div className="position-relative">
        <div className="db1"></div>
        {/* <div className="db2"></div> */}
        {/* <div className="db3"></div> */}
        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>


        <Container className="py-5">
          <Row className="gy-3 ">
            <Col>
              <div className="nftbox-card3 d-flex flex-column h-100 justify-content-start text-white px-4 pt-4 py-3">
                <Row>
                  <Col>
                    <h3 style={{ fontWeight: 700 }}>NFT Box</h3>
                    <p className="nft-card-no mb-1">Total Subscription</p>

                  </Col>
                  <Col className="text-end mt-1">
                    <h5 style={{ fontWeight: 600 }}>${nftBoxValue}</h5>
                    <p className="nft-card-no mb-1">{mntData.amount_mnt}</p>
                  </Col>

                </Row>
                {/* <img src="assets/images/nftbackground.png" className="position-absolute" style={{opacity:0.4}} alt="" /> */}
                <div className="w-100 d-flex flex-row mt-4 justify-content-center gap-4">
                  <img src="assets/images/nftbox2.svg" alt="" />
                  <img
                    className="glow-img img-fluid"
                    src="assets/images/nftbox1.svg "
                    alt="" style={{ minWidth: 240 }}
                  />
                  <img src="assets/images/nftbox2.svg" alt="" />
                </div>
              </div>
            </Col>
            <Col
              style={{ border: "1px solid #ffffff50", borderRadius: 10 }}
              className="d-flex flex-column align-items-center justify-content-center py-3 mx-2"
            >
              <Row className="gy-3">
                <Col lg={12}>
                  <div className="nft-details-column d-flex justify-content-between p-2 highlight">
                    <p className="mb-0">Category</p>
                    <p className="mb-0">{nftBoxDetails.category_name}</p>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="nft-details-column d-flex justify-content-between p-2">
                    <p className="mb-0">Valid Till</p>
                    <p className="mb-0">{nftBoxDetails.validity}</p>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="nft-details-column d-flex justify-content-between p-2">
                    <p className="mb-0">Per Day Reward</p>
                    <p className="mb-0">{nftBoxDetails.reward_percent}</p>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="nft-details-column d-flex justify-content-between p-2">
                    <p className="mb-0">Expire On</p>
                    <p className="mb-0">{nftBoxDetails.expiry_date}</p>
                  </div>
                </Col>
                <div>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                  />
                  <label style={{ marginLeft: 5, color: 'white' }}>I agree with the <Link
                    target="blank"
                    className=" tnc"
                    to={`${config.baseUrl}nftboxtermsandcondition`}
                  >
                    Terms & Conditions{" "}
                  </Link></label>
                </div>
                <Col
                  lg={12}
                  className=" d-flex px-0 align-items-center justify-content-center"
                >
                  <Row className="gy-2 px-0  w-100">
                  <Col lg={6} className=" d-flex justify-content-center">
                      <button className="nftbox-submit w-100" style={{ textDecoration: "none", color: "white" }}
                        onClick={handleBuyNFTBox} >
                        {" "}

                        Subscribe Now
                      </button>
                      {/* <button className='nftbox-submit w-100' >Proceed</button> */}
                    </Col>
                    <Col lg={6} className=" d-flex justify-content-center">
                      <button className="nftbox-submit w-100" onClick={handleAddMore}>
                        {" "}

                        Add More Amount

                      </button>
                      {/* <button className='nftbox-submit w-100' onClick={handleBuyNFTBox}>Proceed</button> */}
                    </Col>

                    
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />

          <div className="swiper-container">
            <button className="swiper-button-prev"></button>
            <button className="swiper-button-next"></button>
            <Swiper
              slidesPerView={3}
              spaceBetween={30}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: { slidesPerView: 1 },  // Small screens
                640: { slidesPerView: 1 },  // Tablets
                1024: { slidesPerView: 3 }, // Desktops
                1440: { slidesPerView: 3 }, // Larger screens
              }}
              modules={[Navigation, Pagination]}
              className="mySwiper"
            >
              {rewardCategoriesDetails.map((category, index) => (
                <SwiperSlide key={index}>

                  <div onClick={category.active ? undefined : () => handleNavigate(category)}
                    style={{ cursor: category.active ? "default" : "pointer" }} className={`${category.current_category == true && "animated-border w-100 h-100"} position-relative `}>

                    {category.active == false &&
                      <div className="custom-locker ">
                        <img src="assets/images/lock03.svg" style={{ width: 30, height: 30, position: "absolute", top: 10, right: 10 }} alt="" />
                      </div>
                    }
                    <div className="nft-detail-card text-white h-100">
                      <div className="nft-inner-card d-flex gap-2 text-white align-items-center">
                        <div className="nft-number2">
                          <div className="nft-number"><img style={{ width: "100%", height: "100%" , borderRadius:"50%"}} src={category.image_url} /></div>
                        </div>
                        <h5 className="mb-0">{category.category_name}</h5>
                      </div>
                      <div className="nft-inner-card2">
                        <p className="mb-1">Subscription Range</p>
                        <h5 style={{ fontWeight: 700 }}>{category.investment_range}</h5>
                        <hr />
                        <p className="mb-1">% Reword</p>
                        <h5 style={{ fontWeight: 700 }}>{category.roi}</h5>
                        <hr />
                        {category.booster.map((booster, boosterIndex) => (
                          <div key={boosterIndex} className="nft-detail-block mb-4 px-2">
                            <Row className="gy-2 p-2">
                              <Col lg={12} className="d-flex justify-content-between align-items-center">
                                <h5 style={{ fontWeight: 700, color: "#00FF26" }}>
                                  Booster %
                                </h5>
                                <h5>{booster.booster_roi}</h5>
                              </Col>
                            </Row>
                            <Row className="gy-2 p-2">
                              <Col lg={12} className={`${category.active == false && "mb-1"} d-flex justify-content-between align-items-center  `}>

                                <p style={{ fontSize: 13, marginBottom: 5 }}>
                                  % Reword After {booster.referral} Referral
                                </p>
                                <p style={{ fontSize: 13, marginBottom: 5 }}>
                                  On Same or Above
                                </p>

                              </Col>
                            </Row>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {showNftSuccessModal &&
            <NftsuccessfulModal
              showNftSuccessModal={setShowNftSuccessModal}
              handleCloseNftSuccessPop={handleCloseNftSuccessPop}
              buyTransactionHash={buyTransactionHash}
              nftBoxValue={nftBoxValue}
            />
          }

          {showModal &&
            <NftboxModal
              showModal={showModal}
              MintingTimer={MintingTimer}
              process={process}
            />
          }

          {showModalLoad &&
            <NftboxLoadModal
              showModalLoad={showModalLoad}
              buyTransactionHash={buyTransactionHash}
              copieBtn={copieBtn}
              redirect={redirect}
            />
          }
        </Container>
      </div>
    </>
  );
};

export default NftboxPurchaseDetails;
